import api, { type ApiResponse, type PageResponse } from './api'
import type { DisputeCaseType, DisputeStatus, MerchantDisputeDetail, MerchantProviderDispute } from '../types/providerDispute'

export function listProviderDisputes(params: { page?: number; size?: number; orderId?: string; subscriptionId?: string; status?: DisputeStatus; caseType?: DisputeCaseType }): Promise<ApiResponse<PageResponse<MerchantProviderDispute>>> {
  return api.get('/v1/merchant/disputes', { params })
}
export function getProviderDispute(id: string): Promise<ApiResponse<MerchantDisputeDetail>> { return api.get(`/v1/merchant/disputes/${id}`) }
